import { render } from "./Referal.vue?vue&type=template&id=5ac7e1d0&scoped=true"
import script from "./Referal.vue?vue&type=script&lang=js"
export * from "./Referal.vue?vue&type=script&lang=js"

import "./Referal.vue?vue&type=style&index=0&id=5ac7e1d0&lang=scss&scoped=true"

import exportComponent from "/var/www/development/hai-parahita-dev.aksamedia.co.id/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ac7e1d0"]])

export default __exports__